import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function decimalNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const valid = /^[0-9]\d*(,\d+)?$/.test(control.value);
    return !valid ? { invalidNumber: { value: control.value, msg: 'Nevalidné číslo.' } } : null;
  };
}
